import React, { useEffect, useRef, useState } from "react";
import VerticalLinearStepper from "../ReusableComponent/StepperComponent";
import CreateEquipmentGroup from "../Equipment-Details/CreateEquipmentGroup";
import AddMenuToEquGroup from "../Equipment-Details/AddMenuToEquGroup";
import RenderFooter from "./RenderFooter";
import AddEquipmentToEquipmentGroup from "../Equipment-Details/AddEquipmentToEquGroup";
import InfoContainer from "./InfoContainer";

import AddBezeichnung from "../Equipment-Details/Bezeichnung/AddBezeichnung";

import AddHerstellerToEquGroup from "../Equipment-Details/AddHerstellerToEquGroup";
import AddHersteller from "../Equipment-Details/Hersteller/AddHersteller";
import AddTestGroupToEquipmentGroup from "../Equipment-Details/AddTestGroupToEquGroup";
import AddPruefGroup from "../Equipment-Details/PruefGroup/AddPruefGroup";
import SelectAttribute from "../Equipment-Details/HandleAttributeSelection/SelectAttributePopOver";
import DigitalCheckList from "../Equipment-Details/PruefPlan/PruefPlanList";

import OptionListPopUp from "../Equipment-Details/HandleAttributeSelection/optionListPopUp";

import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import Summary from "./Summary";
import { itemsState } from "./Content";
import commonUtils from "../../helpers/commonUtils";

import Button from "@mui/material/Button";
import { useLanguageContext } from "../../Context/LanguageContext";
import ConfigurePublicWebsite from "../ConfigurePublicWebsite";
import EquipmentTagIssuePopover from "../EquipmentTagIssuePopover";
import CreateDigitalChecklist from "../Equipment-Details/PruefPlan/AddPruefPlan";
import pruefPlanStores from "../../Stores/PruefPlanStore";
import pruef_PlanConstants from "../../Constants/Pruef_PlanConstants";
import Responsibilty from "./ResponsiblityComp/Responsibilty";
import AddResponsibiltyForm from "./ResponsiblityComp/AddResponsibiltyForm";
import AddChecklistPopUp from "../Equipment-Details/PruefPlan/addChecklistModal";
import Pruef_PlanActions from "../../Actions/Pruef_PlanActions";
import CreateTemplate from "../Equipment-Details/PruefPlan/createTemplate";
const NewEquipmentGroup = (props) => {
  const {
    egDetails,
    plantList,
    selectedPlantId,
    equMenuList,
    orgFunctionsList,
    reloadEquipmentGroupList,
    closeCreatePopOver,
    equGrpDetails,
    setEgDetails,
    handleActionButtons,
  } = props;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [activeStep, setActiveStep] = React.useState(0);
  const [equipmentGrpId, setEquipmentGrpId] = React.useState(0);
  const [equipmentGrpName, setEquipmentGrpName] = React.useState(null);
  const [isSaveEqGrp, setIsSaveEqGrp] = React.useState(false);
  const [resetComponent, setResetComponent] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [scanOptionEqGrp, setScanOptionEqGrp] = React.useState(null);
  const [isKostenstelleNew, setIsKostenstelleNew] = React.useState(false);
  const [pruefPlanIdNew, setPruefPlanIdNew] = React.useState("");
  const [viewModeOnlyNew, setviewModeOnlyNew] = React.useState(false);
  const [questionviewModeOnlyNew, setQuestionviewModeOnlyNew] = useState(false);
  const [sndPruefDetailQuestionNew, setSndPruefDetailQuestionNew] =
    useState("");
  const [pruefplaneEqgrp, setPruefplaneEqgrp] = useState(0);
  const [resetEquipmentForm, setResetEquipmentForm] = useState(false);
  const optionListRef = useRef("");
  const [newOptionList, setNewOptionList] = React.useState("");
  const [isKonst, setIsKost] = React.useState(false);
  const [isIndiviual, setIsIndiviual] = React.useState(false);
  const [completedPercentage, setCompletedPercentage] = React.useState(0);
  const [showInfo, setShowInfo] = React.useState(false);
  const [isCompleted, setIscompleted] = React.useState(itemsState);
  const [eqtagIssueType, setEqtagIssueType] = React.useState(null);
  const [eqtagIssueList, setEqTagIssueList] = React.useState(null);
  const [checkListDetails, setCheckListDetails] = useState("");
  const [getEqupGrupUserListFlag, setEqupGrupUserListFlag] = useState(false);
  const [addChecklistModalFlagFromWizard, setaddChecklistModalFlagFromWizard] =
    useState(false);
  const [
    isChecklistFromTemplateFromWizard,
    setIsChecklistFromTemplateFromWizard,
  ] = useState(false);
  const [
    isCreateTemplateModalOpenFromWizard,
    setIsCreateTemplateModalOpenFromWizard,
  ] = useState(false);
  const [
    checklistDataForTemplateFromWizard,
    setChecklistDataForTemplateFromWizard,
  ] = useState("");

  const steps = [
    {
      key: "equipmentGroup",
      label: localization.eqGrpLabel,
      componentName: CreateEquipmentGroup,
      Data: {
        egDetails,
        plantList,
        selectedPlantId,
        reloadEquipmentGroupList,
        closeCreatePopOver,
        setEquipmentGrpId,
        handleCompleted,
        setActiveStep,
        isSaveEqGrp,
        setIsSaveEqGrp,
        resetComponent,
        setResetComponent,
        equipmentGrpId,
        scanOptionEqGrp,
        setScanOptionEqGrp,
        resetEquipmentForm,
        setResetEquipmentForm,
        setEquipmentGrpName,
        setIsKost,
        setIsIndiviual,
        setIsEdit,
        setEgDetails,
        setShowInfo,
      },
    },
    {
      key: "AddEquipment",
      label: localization.addEquipmentLabel,
      componentName: AddEquipmentToEquipmentGroup,
      Data: {
        egDetails,
        equipmentGrpName,
        handleCompleted,
        equipmentGrpId,
        setShowInfo,
      },
    },
    {
      key: "AddManufacture",
      label: localization.addMenufactureLabel,
      componentName: AddHerstellerToEquGroup,
      Data: {
        egDetails,
        equipmentGrpName,
        handleCompleted,
        equipmentGrpId,
        setShowInfo,
      },
    },

    {
      key: "AddMenu",
      label: localization.menuLabel,
      componentName: AddMenuToEquGroup,
      Data: {
        egDetails,
        equMenuList,
        equipmentGrpName,
        handleCompleted,
        equipmentGrpId,
        handleNext,
        setShowInfo,
      },
    },

    {
      key: "AddAttribute",
      label: localization.standardAttribureLabel,
      componentName: SelectAttribute,
      Data: {
        egDetails,
        handleCompleted,
        equipmentGrpId,
        handleRef,
        newOptionList,
      },
    },
    {
      key: "AddTestGroup",
      label: localization.testGrpLabel,
      componentName: AddTestGroupToEquipmentGroup,
      Data: {
        egDetails,
        equipmentGrpName,
        equipmentGrpId,
        handleCompleted,
        setShowInfo,
      },
    },
    {
      key: "AddTestPlan",
      label: localization.addChecklist,
      componentName: DigitalCheckList,
      Data: {
        egDetails,
        equipmentGrpName,
        setIsKostenstelleNew,
        setPruefPlanIdNew,
        setviewModeOnlyNew,
        setQuestionviewModeOnlyNew,
        setSndPruefDetailQuestionNew,
        equipmentGrpId,
        setPruefplaneEqgrp,
        handleCompleted,
        setaddChecklistModalFlagFromWizard,
        setIsChecklistFromTemplateFromWizard,
        setIsCreateTemplateModalOpenFromWizard,
        setChecklistDataForTemplateFromWizard,
      },
    },
    {
      key: "Public Website",
      label: localization.publicwebsite,
      componentName: ConfigurePublicWebsite,
      Data: {
        equipmentGrpId,
        setEqtagIssueType,
        setEqTagIssueList,
      },
    },
    {
      key: "responsibility",
      label: localization.responsibility,
      componentName: Responsibilty,
      Data: { equipmentGrpId, setEqupGrupUserListFlag },
    },
    {
      key: "summary",
      label: localization.summaryLabel,
      componentName: Summary,
      Data: {
        egDetails,
        equipmentGrpId,
        equipmentGrpName,
        handleCompleted,
        isKonst,
        isIndiviual,
      },
    },
  ];

  const [renderResponse, setRenderResponse] = React.useState(null);

  useEffect(() => {
    if (renderResponse) {
      let testGrp;
      const testPlan =
        renderResponse["testPlanCount"] === 0
          ? false
          : renderResponse["publishTestPlanCount"] ===
            renderResponse["testPlanCount"];
      if (isIndiviual) {
        testGrp = renderResponse["testGroupsCount"] === 0 ? false : true;
      } else {
        testGrp =
          renderResponse["testGroupsCount"] === 0
            ? false
            : renderResponse["testGroupsWithoutTestPlan"].length === 0;
      }
      setIscompleted({
        ["equipmentGroup"]: true,
        ["AddEquipment"]:
          renderResponse["equipmentNamesCount"] === 0 ? false : true,
        ["AddManufacture"]:
          renderResponse["manufacturesCount"] === 0 ? false : true,
        ["AddMenu"]: renderResponse["menusCount"] === 0 ? false : true,
        ["AddAttribute"]:
          renderResponse["attributesCount"] === 0 ? false : true,
        ["AddTestGroup"]: testGrp,
        ["AddTestPlan"]: testPlan,
      });
    }
  }, [renderResponse]);

  useEffect(() => {
    setShowInfo(false);
  }, [activeStep]);

  useEffect(() => {
    if (egDetails !== "") {
      setEquipmentGrpName(egDetails.bezeichnung);
      setEquipmentGrpId(egDetails.id);
      setIsKost(egDetails.pruefKriterium.toLowerCase() === "kost");
      setIsIndiviual(false);
      setIsEdit(true);
    }
  }, [egDetails]);

  useEffect(() => {
    function getSummarySuccess() {
      var res = equipmentGroupStore.getSummaryEqGrpResult();
      if (res) {
        setRenderResponse(res);
      }
      setGlobalSpinner(false);
    }

    function getSummaryFailure() {
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_SUMMARY_EQ_GRP_SUCCESS,
      getSummarySuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_SUMMARY_EQ_GRP_FAILURE,
      getSummaryFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_SUMMARY_EQ_GRP_SUCCESS,
        getSummarySuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_SUMMARY_EQ_GRP_FAILURE,
        getSummaryFailure,
      );
    };
  }, []);

  function handleNext() {
    if (activeStep === 0) {
      setIsSaveEqGrp(true);
    } else {
      if (isKonst && activeStep === 4) {
        setActiveStep(isIndiviual ? 7 : 6);
      } else if (isIndiviual && activeStep === 5) {
        setActiveStep(7);
      } else if (true) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
  }

  const handleBack = () => {
    if (isIndiviual && activeStep === 7) {
      setActiveStep(isKonst ? 4 : 5);
    } else if (isKonst && activeStep === 6) {
      setActiveStep(4);
    } else if (true) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleStepClick = (_index) => {
    if (activeStep !== _index) setActiveStep(_index);
  };

  function getCheckListDetailsFromEquipmentGrpWizard(id) {
    setGlobalSpinner(true);
    Pruef_PlanActions.getChecklistDetails(id);
  }

  const handlePopOverclose = () => {
    commonUtils.hideModalPopUp("newEquipmentGroupClose");
    setEquipmentGrpId(0);
    setIsIndiviual(false);
    setIsKost(false);
    setEquipmentGrpName("");
    setActiveStep(0);
    setResetComponent(true);
    setIsEdit(false);
    setEgDetails("");
    setResetEquipmentForm(true);
    setIscompleted(itemsState);
    if (showInfo) {
      setShowInfo(false);
    }
  };
  useEffect(() => {
    const _completed = Object.keys(isCompleted).filter((item) => {
      return (
        isCompleted[item] &&
        !(
          (isKonst && item === "AddTestGroup") ||
          (isIndiviual && item === "AddTestPlan")
        )
      );
    }).length;
    const _totalstep = isKonst ? (isIndiviual ? 5 : 6) : isIndiviual ? 6 : 7;
    let percentage;
    if (_completed) {
      percentage = (_completed / _totalstep) * 100;
    } else {
      percentage = 0;
    }
    setCompletedPercentage(percentage);
  }, [isCompleted]);

  function handleCompleted(_name, _value) {
    setIscompleted((prev) => ({ ...prev, [_name]: _value }));
  }
  function handleRef(_egDetails, _attrData) {
    optionListRef.current.handleLoad(_egDetails, _attrData);
  }

  function handleOptionsListPopUpSaveCallback(_attrId, _optionList) {
    setNewOptionList({ _attrId, _optionList });
  }

  function handleClosePopOverTagIssue() {
    setEqTagIssueList(null);
  }

  useEffect(() => {
    function getCheckListDetailSuccess() {
      const res = pruefPlanStores.getCheckListDetails();
      if (res) {
        setCheckListDetails(res);
      } else {
        setCheckListDetails([]);
      }
      setGlobalSpinner(false);
    }
    function getCheckListDetailFailure() {
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_DETAILS_SUCCESS,
      getCheckListDetailSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_DETAILS_FAILURE,
      getCheckListDetailFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_DETAILS_SUCCESS,
        getCheckListDetailSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_DETAILS_FAILURE,
        getCheckListDetailFailure,
      );
    };
  }, []);

  const saveAsTemplateCallbackFromWizard = (event) => {
    commonUtils.hideModalPopUp("addDigitalChecklistModalClose");
    setChecklistDataForTemplateFromWizard("");
    setIsCreateTemplateModalOpenFromWizard(false);
    setaddChecklistModalFlagFromWizard(false);
  };

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id="newEquipmentGroup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="newEquipmentGroup"
        aria-hidden="true"
        data-backdrop="static"
        data-focus="false"
      >
        <div className="custom-modal modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="newEquipmentGroup">
                {equipmentGrpName !== ""
                  ? equipmentGrpName
                  : localization.createEquipmentGroup}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="newEquipmentGroupClose"
                onClick={handlePopOverclose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body newEqGrpModal">
              <div className="container-fluid w-100">
                <div className="row newEqGrpModalBody">
                  <div className="col-3 pl-0 pr-0 border-right">
                    <VerticalLinearStepper
                      activeStep={activeStep}
                      steps={steps.map((step) => ({
                        label: step.label,
                        key: step.key,
                      }))}
                      handleNext={handleNext}
                      handleBack={handleBack}
                      handleStepClick={handleStepClick}
                      isEdit={isEdit}
                      isCompleted={isCompleted}
                      isKonst={isKonst}
                      isIndiviual={isIndiviual}
                    />
                  </div>

                  <div
                    className={`col-9 pl-2 border-right  ${
                      steps[activeStep].key === "summary" ? "colBgCl" : ""
                    }`}
                  >
                    {steps[activeStep].key !== "summary" && (
                      <div className="row justify-content-end pr-2">
                        <Button
                          size="large"
                          className="infoButtonStyle"
                          // style={{ fontSize: "14px" }}
                          onClick={() => {
                            setShowInfo(true);
                          }}
                        >
                          {localization.help}
                        </Button>
                      </div>
                    )}

                    {activeStep < steps.length &&
                      steps[activeStep].componentName &&
                      React.createElement(steps[activeStep].componentName, {
                        data: steps[activeStep].Data,
                      })}
                  </div>
                  {showInfo && (
                    <div className="col pl-2 overrideCol p-5">
                      <InfoContainer
                        setShowInfo={setShowInfo}
                        activeStep={activeStep}
                        label={steps[activeStep].label}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer pt-5 pb-0">
              <RenderFooter
                completedPercentage={completedPercentage}
                activeStep={activeStep}
                handleNext={handleNext}
                handleBack={handleBack}
                handleComplete={handlePopOverclose}
              />
            </div>
          </div>
        </div>
      </div>
      <EquipmentTagIssuePopover
        typeReport={eqtagIssueType}
        equipmentTagIssueList={eqtagIssueList}
        handleClosePopOverTagIssue={handleClosePopOverTagIssue}
        equipmentGrpName={equipmentGrpName}
      />
      <AddBezeichnung
        bezeichnungDetails={""}
        equipmentGrpName={equipmentGrpName}
        closeAddBezeichnungPopUpCallback={() => {}}
      />
      <AddResponsibiltyForm
        getEqupGrupUserListFlag={getEqupGrupUserListFlag}
        equipmentGrpId={equipmentGrpId}
        closeAddEditResponsibiltyPopUpCallback={() => {
          setEqupGrupUserListFlag(false);
        }}
      />
      <AddHersteller
        herstellerDetails={""}
        equipmentGrpName={equipmentGrpName}
        closeAddEditHerstellerPopUpCallback={() => {}}
      />
      <AddPruefGroup
        prufePlanDetails={""}
        equipmentGrpName={equipmentGrpName}
        closeAddEditPruefGroupPopUpCallback={() => {}}
      />

      <CreateDigitalChecklist
        isWizard={true}
        isKostenstelleFlag={isKostenstelleNew}
        equipmentGroupName={equipmentGrpName}
        pruefPlanId={pruefPlanIdNew}
        egId={pruefplaneEqgrp}
        closePrufePlanEditPopUpCallback={() => {
          setPruefplaneEqgrp(0);
          setCheckListDetails("");
        }}
        viewModeOnly={viewModeOnlyNew}
        checkListDetails={checkListDetails}
        addChecklistFlag={addChecklistModalFlagFromWizard}
        isChecklistFromTemplate={isChecklistFromTemplateFromWizard}
        setIsCreateTemplateModalOpen={setIsCreateTemplateModalOpenFromWizard}
        setChecklistDataForTemplate={setChecklistDataForTemplateFromWizard}
      />
      <OptionListPopUp
        ref={optionListRef}
        handleOptionsListPopUpSaveCallback={handleOptionsListPopUpSaveCallback}
      />
      {addChecklistModalFlagFromWizard && (
        <AddChecklistPopUp
          setAddChecklistModalOpen={setaddChecklistModalFlagFromWizard}
          getCheckListDetails={getCheckListDetailsFromEquipmentGrpWizard}
          setviewModeOnly={setviewModeOnlyNew}
          setIsChecklistFromTemplate={setIsChecklistFromTemplateFromWizard}
          handleActionButtons={handleActionButtons}
        />
      )}
      {isCreateTemplateModalOpenFromWizard && (
        <CreateTemplate
          isCreateTemplateModalOpen={isCreateTemplateModalOpenFromWizard}
          checklistDataForTemplate={checklistDataForTemplateFromWizard}
          saveAsTemplateCallback={saveAsTemplateCallbackFromWizard}
        />
      )}
    </React.Fragment>
  );
};

export default NewEquipmentGroup;
